import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CTABlock = ({ title, subtitle, hide, colourScheme, link, arrow, id, onClick }) => {
  const componentClasses = classNames('cta-block', {
    [`cta-block--hide-on-${hide}`]: hide,
    [`cta-block--${colourScheme}`]: colourScheme
  });

  return (
    <a href={link} className={componentClasses} id={id} onClick={onClick}>
      {title}
      <span>{subtitle}</span>
      <img alt="arrow-right" src={arrow} />
    </a>
  );
};

CTABlock.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  hide: PropTypes.oneOf(['mobile', 'desktop']),
  colourScheme: PropTypes.oneOf(['dark-navy', 'teal']),
  link: PropTypes.string,
  arrow: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func
};

export default CTABlock;
